<template>
  <div class="nested-wrapper-footer-menu-sub-wrapper">
    <VueNestable
      v-if="menus && menus.length > 0"
      :class="{'position-unset-li': showMenuTool}"
      v-model="menus"
      :maxDepth="1"
      :childrenProp="null"
      @change="changeData"
    >
      <template slot-scope="{ item }">
        <VueNestableHandle  class="handler" :item="item">
          <div
            class="panel-item-footer-menu-sub"
            :class="{  
              active: expand_id === `tools${item.id}`,
              bactive: expand_id
            }"
            :draggable="!disableDrag"
          >
            <div class="d-flex align-items-center">
              <DragIcon class="drag-icon bi-three-dots-vertical drag-icon b-icon bi text-dark handle"></DragIcon>
              <span class="fs-sa-14 ml-gd-1">{{ item.properties.name }}</span>
            </div>
            <span
              class="icon-eye disabled text-muted dis"
              v-if="item.properties.isEnable === false"
            >
              <EyeSlash></EyeSlash>
            </span>
            <div
              class="tool cursor-pointer"
              @mouseover="$emit('mouseoverCustom')"
              @mouseleave="$emit('mouseleaveCustom')"
            >
              <div 
                class="cursor-pointer tools-more-menu sub-menu"
                :id="`tools${item.id}`"
                @click.stop="fixExpand(item)"
                @touchstart.stop="disableDrag = true"
                @touchend.stop="fixExpand(item)"
                :class="{active: expand_id === `tools${item.id}`}"
                >
                <Ellipsis
                  class="mb-3 icon-more-menu"
                  style="pointer-events: none; font-size: 14px"
                ></Ellipsis>
              </div>
              <b-popover
                :target="`tools${item.id}`"
                placement="right"
                triggers="click"
                :ref="`popover-menu-sub-${item.id}`"
                :show="expand_id === `tools${item.id}`"
                :container="`tools${item.id}`"
                boundary="viewport"
              >
                <div>
                  <div
                    class="cursor-pointer option"
                    @click="edit(item.id)"
                  >
                    <div style="pointer-events: none;">
                      <span>
                        <i class="far fa-edit"></i>
                      </span>
                      {{$t("engine.manageFooter.manu.edit",languageEngine)}}
                    </div>
                  </div>
                  <div
                    class="cursor-pointer option"
                    @click="statusChange(item.id)"
                  >
                    <div style="pointer-events: none;">
                      <span v-show="item.properties.isEnable">
                        <i class="far fa-eye"></i>
                      </span>
                      <span v-show="!item.properties.isEnable">
                        <i class="far fa-eye-slash"></i>
                      </span>
                      {{ !item.properties.isEnable ?  $t("engine.manageFooter.manu.show",languageEngine) :  $t("engine.manageFooter.manu.hide",languageEngine) }}
                    </div>
                  </div>
                  <div
                    class="cursor-pointer option"
                    @click="$emit('preDelete', item)"
                  >
                    <div style="pointer-events: none;">
                      <span>
                        <i class="far fa-trash-alt"></i>
                      </span>
                        {{$t("engine.manageFooter.manu.delete",languageEngine)}}
                    </div>
                  </div>
                </div>
              </b-popover>
            </div>
          </div>
        </VueNestableHandle>
      </template>
    </VueNestable>
    <div class="help-empty text-center" v-else>
      {{$t("engine.manageFooter.manu.lblDescriptAddMenu",languageEngine )}}
    </div>
    
  </div>
</template>

<script>
import { VueNestable, VueNestableHandle } from "vue-nestable";
import { mapGetters } from "vuex";
import DragIcon from "@components_system/Shared/Images/Icon/DragIcon";
import Ellipsis from "@components_system/Shared/Images/Icon/Ellipsis";
import EyeSlash from "@components_system/Shared/Images/Icon/EyeSlash";
// require("@assets/plugins/vue-nestable/vue-nestable.scss");
export default {
  data() {
    return {
      expand_id: "",
      menus :[],
      showMenuTool: false,
      disableDrag: false,
    }
  },
  components: {
    VueNestable,
    VueNestableHandle,
    DragIcon,
    Ellipsis,
    EyeSlash,
  },
  methods: {
    init() {
      this.menus = this.siteComponents[this.activeMainId].componentsID.map((item) => {
            return this.siteComponents[item];
          }) || []
    },
    changeData() {
      this.siteComponents[this.activeMainId].componentsID = JSON.parse(
        JSON.stringify(
          this.menus.map((i) => {
            return i.id;
          })
        )
      );
      this.$store.dispatch("design/snapshot/genSnapshot", { type: "menu" });
    },  
    addMenu() {
      this.$bvModal.hide("modal-manage-footer-menu");
      this.$bvModal.show("modal-footer-menu");
    },
    edit(menuID) {
      this.$emit('edit', menuID)
    },
    statusChange(id) {
      this.siteComponents[id].properties.isEnable =
        !this.siteComponents[id].properties.isEnable;
      this.$store.dispatch("design/snapshot/genSnapshot", { type: "menu" });
      this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), 
      message: this.$t(`${this.siteComponents[id].properties.isEnable ? "engine.manageFooter.menu.alert.msgShowMenuSuccess":"engine.manageFooter.menu.alert.msgHideMenuSuccess"}`) });
    },
    preventScroll(e) {
      e.preventDefault();
    },
    disable() {
      document
        .querySelector(".modal-body")
        .addEventListener("wheel", this.preventScroll);
      this.disableDrag = true;
    },
    enable() {
      document
        .querySelector(".modal-body")
        .removeEventListener("wheel", this.preventScroll, false);
      this.disableDrag = false;
    },
    fixExpand(item) {
      if (!this.expand_id || this.expand_id == '' || (this.expand_id && this.expand_id != `tools${item.id}`)) {
        this.expand_id = String(`tools${item.id}`);
        this.showMenuTool = true
        document.querySelector(".modal-body").addEventListener("click", this.checkAreaMouseClick)
        this.disable();
      }else {
        document.querySelector(".modal-body").removeEventListener("click", this.checkAreaMouseClick, false)
        this.expand_id = "";
        this.showMenuTool = false
        this.enable();
      }
    },
    checkAreaMouseClick(event) {
      if (!(event.target.classList.contains('tools-more-menu') && event.target.classList.contains('sub-menu'))) {
        document.querySelector(".modal-body").removeEventListener("click", this.checkAreaMouseClick, false)
        this.expand_id = ""
        this.showMenuTool = false
        this.enable();
      }
    },
  },
  mounted() {
    this.init();
    this.$root.$on("bv::modal::shown", () => {
      const _vm = this;
      $(".modal").on("click", function (bvEvent) {
        if (
          _vm.expand_id &&
          bvEvent.target.className != "cursor-pointer tools-more-menu active"
        ) {

          _vm.$root.$emit("bv::hide::popover", _vm.expand_id);
          _vm.expand_id = "";
          _vm.enable();
        }
      });
    });
  },
  watch: {
    activeMainId() {
      this.init()
    },

  },
  computed: {
    ...mapGetters({
      siteComponents: "design/metadata/siteComponents",
      languageEngine: "design/userPreference/languageEngine",
    }),
    menu() {
      return this.siteComponents.FOOTER_WIDGET_MENU;
    },
  },
  props: {
    activeMainId: {
      required: true,
    },
    setIsExpandToolID: {
      default: "",
    }
  },
};
</script>

<style lang="scss">
.nested-wrapper-footer-menu-sub-wrapper {
  overflow-y: scroll;
  height: calc(100% - 32px);
  .nestable {
    position: unset !important; 
  }
  .my-class{
    position: unset !important; 
  }
  .position-unset-li li { position: unset !important; }
  /* .nestable-item {
    position: unset !important; 
  } */
  .nestable-item .nestable-item-content {
    &::before {
      transition: all 0.2s ease;
      content: '';
      height: 1px;
      width: 15px;
      background-color: #DFDFDF;
      position: absolute;
      top: 18px;
      left: -15px;
      margin: auto;
    }
    &::after {
      transition: all 0.2s ease;
      content: '';
      width: 1px;
      height: calc(100% + 10px);
      background-color: #DFDFDF;
      position: absolute;
      top: 0;
      bottom: 0;
      left: -15px;
      margin-top: -10px;
    }
  }
  .nestable-item:last-child  > .nestable-item-content {
      &::after {
        transition: all 0.1s ease;
        height: 28px;
      }
  }
  .nestable-group > .nestable-item > .nestable-item-content {
    &::before {
      display: none;
    }
    &::after {
      display: none;
    }
  }
  .nestable-item .nestable-item-content .nestable-handle { 
    .b-icon {
      color: #DEE3E6 !important;
    }
  }
  .nestable-item .nestable-item-content .nestable-handle :hover { 
    .b-icon {
      color: #373E44 !important;
    }
  }

  .panel-item-footer-menu-sub {
    margin-top: 8px;
    margin-bottom: 8px;
    position: static;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background-color: #fff;
    border: 1px solid #DEE3E6;
    border-radius: 4px;
    transition: background-color 0.2s ease-out;
    &.disabled {
      color: #A5A5A5;
    }
    &.hover, &:hover {
      background: #f4fcff;
      cursor: pointer;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
      border: 1px solid #24BEE2;
    }
    .panel-tool{
      color: #53585D;
    }
    .tool {
        display: none;
    }
    .icon-eye {
      height: 16px;
      display: flex;
      align-items: center;
    }
    &:hover {
      background-color: #F8F9FA;
      .tool {
          display: block;
      }    
      .disabled.text-muted {
          display: none;
      }
    }
    &.bactive.active , .bactive:active{
      .tool {
          display: block;
      }
    }
    .tools-more-menu {
      width: 20px;
      height: 20px;
      padding: 0;
      border-radius: 50%;
      background: transparent;
      border: none;
      text-align: center;
      color: #8E969E !important;
      outline: 1px solid #BDEBF6;
      &:hover {
          outline: 2px solid #BDEBF6;
      }
      &.active{
          outline: 2px solid #24BEE2;
          color: #8E969E  !important;
      }
    }
    .popover {
      margin-top: -12px;
      margin-left: 14px;
      width: 150px;
      border: 1px solid #CED4DA;
      border-radius: 4px;
      box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.176);
      background: #FFFFFF;
      padding: 0px ;
      .arrow {
        display: none;
      }
      .popover-body {
        padding: 10px 0;
        .option {
          color: #373E44;
          padding: 5px 20px;
        }
      }
    }
  }
}
</style>